import moment from 'moment';

const values = [
  // < 1mo
  {
    tempMin: 96,
    tempMax: 99,
    hrMin: 120,
    hrMax: 160,
    rrMin: 30,
    rrMax: 50,
    bpSMin: 50,
    bpSMax: 70,
    bpDMin: 30,
    bpDMax: 60,
  },
  // 1mo - 12mos, i.e. 1 mo <= x < 12 mos (for all intervals below)
  {
    tempMin: 96,
    tempMax: 99,
    hrMin: 80,
    hrMax: 140,
    rrMin: 20,
    rrMax: 30,
    bpSMin: 70,
    bpSMax: 100,
    bpDMin: 53,
    bpDMax: 66,
  },
  // 1yr - 3yr
  {
    tempMin: 96,
    tempMax: 99,
    hrMin: 80,
    hrMax: 130,
    rrMin: 20,
    rrMax: 30,
    bpSMin: 80,
    bpSMax: 110,
    bpDMin: 53,
    bpDMax: 66,
  },
  // 3yr - 5yr
  {
    tempMin: 96,
    tempMax: 99,
    hrMin: 80,
    hrMax: 120,
    rrMin: 20,
    rrMax: 30,
    bpSMin: 80,
    bpSMax: 110,
    bpDMin: 55,
    bpDMax: 69,
  },
  // 6yr - 13yr
  {
    tempMin: 96,
    tempMax: 99,
    hrMin: 70,
    hrMax: 110,
    rrMin: 20,
    rrMax: 30,
    bpSMin: 80,
    bpSMax: 120,
    bpDMin: 57,
    bpDMax: 71,
  },
  // 13y - 15y
  {
    tempMin: 96,
    tempMax: 99,
    hrMin: 55,
    hrMax: 115,
    rrMin: 15,
    rrMax: 25,
    bpSMin: 94,
    bpSMax: 120,
    bpDMin: 62,
    bpDMax: 80,
  },
  // 15y-19y
  {
    tempMin: 96,
    tempMax: 99,
    hrMin: 60,
    hrMax: 100,
    rrMin: 12,
    rrMax: 20,
    bpSMin: 94,
    bpSMax: 120,
    bpDMin: 62,
    bpDMax: 80,
  },
  // >= 19y
  {
    tempMin: 96,
    tempMax: 99,
    hrMin: 60,
    hrMax: 100,
    rrMin: 12,
    rrMax: 20,
    bpSMin: 90,
    bpSMax: 120,
    bpDMin: 60,
    bpDMax: 80,
  },
];

export default function getThresholds(dob: string, date: string) {
  if (!dob || !date) {
    return {};
  }
  const monthsDiff = moment(date).diff(dob, 'months');
  const yearsDiff = moment(date).diff(dob, 'years');
  let index = 0;
  if (yearsDiff >= 19) {
    index = 7;
  } else if (yearsDiff >= 15) {
    index = 6;
  } else if (yearsDiff >= 13) {
    index = 5;
  } else if (yearsDiff >= 6) {
    index = 4;
  } else if (yearsDiff >= 3) {
    index = 3;
  } else if (yearsDiff >= 1) {
    index = 2;
  } else if (monthsDiff >= 1) {
    index = 1;
  }
  return values[index];
}



// WEBPACK FOOTER //
// ./client/src/components/patientPages/vitals/getThresholds.js